<template>
  <a
    :href="
      `${membershipBaseUrl}/membership/tiers/access`
    "
    class="
      @1024/layout/padding
      @600/layout/width:100%
      @768/layout/flex:row
      @768/layout/padding:page:0.5
      $color/background:membership:7
      $color/membership:18
      $layout/page:fixed
      color/background
      layout/flex:column
      layout/padding:page
      layout/width:100%
      layout/relative
    "
    style="
      justify-content: space-between;
      --1024--layout--padding: 5.6rem;
    "
    >
    <div
      class="
        @1280/layout/absolute
        @1280/layout/block
        @1280/layout/bottom:0%
        @1280/layout/height
        @1280/layout/left:auto
        @1280/layout/right
        @1280/layout/top:0%
        color/all
        layout/none
      "
      style="
        --1280--layout--right: 5rem;
      "
      v-html="artwork"
      />
    <div
      class="
        @1024/layout/margin:right:page
        @1024/layout/width
        layout/flex
        layout/flex:column
        layout/width:100%
      "
      style="
        --1024--layout--width: var(--uneven-column-width--main);
      "
      >
      <h2
        class="
          @1024/$typography/size:22pt
          @768/$typography/size:18pt
          $typography/size:16pt
          typography
        "
        >
        <span
          class="layout/block balance-text"
          v-html="i18n.t('paywall-banner__access_membership_tagline')"
        />
      </h2>
      <div
        class="
          @768/layout/margin:top:page:0.5
          @768/layout/none
          $typography/size:14pt
          layout/block
          layout/margin:top:page
          typography/markdown
        "
        >
        <p
          class="typography layout/block balance-text"
          v-html="i18n.t('paywall-banner__access_membership_benefit__all')"
        />
      </div>
      <div
        class="
          @1024/$typography/size:18pt
          @768/layout/block
          $typography/size:14pt
          layout/margin:top
          layout/none
          typography/markdown
        "
        style="
          --layout--margin--top: 2.4rem;
        "
        >
        <ul>
          <li
            style="
              --layout--margin--top: 2rem;
            "
            class="layout/padding:left:cap:1.5"
            >
            <span
              class="layout/block"
              v-html="i18n.t('paywall-banner__access_membership_benefit__free_admission')"
            />
          </li>
          <li
            style="
              --layout--margin--top: 2rem;
            "
            class="layout/padding:left:cap:1.5"
            >
            <span
              class="layout/block"
              v-html="i18n.t('paywall-banner__access_membership_benefit__store_discount')"
            />
          </li>
          <li
            style="
              --layout--margin--top: 2rem;
            "
            class="layout/padding:left:cap:1.5"
            >
            <span
              class="layout/block"
              v-html="i18n.t('paywall-banner__access_membership_benefit__digital_content')"
            />
          </li>
        </ul>
      </div>
      <div
        class="
          @768/layout/margin:top:cap:4
          layout/margin:top:page
        "
        >
        <div
          class="
            $typography/size:medium
          "
          >
          <iconLink
            :link-url="`${membershipBaseUrl}/membership/tiers/access`"
            :gtm="gtm"
            :text="i18n.t('paywall-banner__learn_more_cta')"
            text-color="$color/white"
            :external="false"
          />
        </div>
      </div>
      <div
        class="
          layout/none
          @768/layout/block
          @768/layout/margin:top:page:0.5
          @1024/layout/margin:top:page
        "
        >
        <p
          class="
            $typography/baseline:body
            $typography/size:14pt
            $typography/weight:regular
            @1024/$typography/size:18pt
            typography
          "
          v-html="i18n.t('paywall-banner__access_membership__billed_annually')"
        />
      </div>
    </div>
  </a>
</template>

<script>
import i18n from '../../utils/i18n';
import iconLink from '../shared/links/link.vue';
import { embedSVG } from '../../helpers/embedSVG';

export default {
  components: {
    iconLink,
  },
  props: {
    gtmContext: { type: String, required: true },
    membershipBaseUrl: { type: String, required: true },
  },
  data: function () {
    return {
      i18n: new i18n(),
    };
  },
  computed: {
    gtm() {
      return `${this.gtmContext} / paywall / learn more`;
    },
    artwork() {
      return embedSVG("member_lines/member-promo-desktop-big.svg", "layout/height:100%");
    },
  },
};
</script>